import Vue from 'vue';
import axios from 'axios';
import { Loading, Message } from 'element-ui';
import router from '../router/index.js';
import utils from '@/utils/getApiSign';
// import { delete } from 'vue/types/umd';

let loading;
let _this = this;

// 显示加载中遮罩层
function startLoading() {
    loading = Loading.service({
        lock: true,
        text: '加载中',
        background: 'rgba(0, 0, 0, 0.7)'
    });
};

// 关闭加载中遮罩层
function endLoading() {
    if (loading) loading.close();
};

// 请求拦截
axios.interceptors.request.use(
    (confing) => {
        // console.log(confing,22222222)
        var isHideStartLoading = localStorage.getItem('isHideStartLoading');
        if (isHideStartLoading == "Y") {
            localStorage.removeItem('isHideStartLoading')
        } else {
            startLoading();
        }
        // startLoading();
        //设置请求头
        var loginData = JSON.parse(localStorage.getItem('loginData')) || '';
        if (loginData.access_token) {
            confing.headers.Authorization = loginData.access_token;
        }
        // confing.headers['API-SIGN'] = utils.getApiSign(confing.params || confing.data || {});
        return confing;
    },
    (error) => {
        endLoading();
        return Promise.reject(error);
    }
)

//响应拦截
axios.interceptors.response.use(
    (response) => {
        endLoading();
        if ((response.data.code === 500 || response.data.code === 401) && (response.data.msg === '令牌验证失败' || response.data.msg === '令牌不能为空')) {
            // console.log(_this,route);
            if (router.path != '/login') {
                Message.error('请重新登录');
            }
            localStorage.removeItem('loginData');
            router.push('/login');
            return Promise.reject(response);
            // } else {
            //     return response.data || {};
            // }
        } else if (response.data.code === 500) {
            Message({
                message: response.data.msg ,
                type: 'error'
              })
            return response.data;
        } else {
            return response.data || {};
        }
    },
    (error) => {
        endLoading();
        Message.error(error.response.data);
        // this.$message.err(error);
        // 获取状态码
        const { status } = error.response;
        if (status === 401) {
            Message.error('请重新登录');
            //清除token
            localStorage.removeItem('loginData');
            //跳转到登录页面
            router.push('/login');
        }
        return Promise.reject(error);
    }
)
export default axios;
